<form style="padding: 25px">
  <div class="flex flex-col xl:flex-row gap-2 justify-between">
    <span class="flex justify-start items-center text-black font-black uppercase"> Lista de Empresas </span>
    <div class="flex justify-start lg:justify-end flex-wrap gap-2">
      <select
        class="w-60 p-2 form-select form-select-lg mr-5 text-white font-medium btn--primary"
        aria-label="Ordenação"
        [formControl]="ordenarControl"
      >
        <option disabled>Ordenar</option>
        <option *ngFor="let order of listOrder" [value]="order.value">{{ order.label }}</option>
      </select>

      <app-status-filter [formControl]="statusControl"></app-status-filter>

      <div>
        <input [formControl]="acaoInput" type="text" class="form-input w-64" placeholder="Pesquise por Nome ou CNPJ" />
      </div>
      <div class="flex justify-between">
        <button (click)="filtrarEmpresa()" title="Filtrar Empresas" class="px-5 min-w-max btn btn--secondary h-35 ml-5">
          <img class="w-6 h-6" src="./assets/icons/search_white.svg" alt="search" />
        </button>
        <button
          (click)="limparFiltros()"
          title="Limpar Filtros"
          class="px-5 min-w-max btn btn--primary h-35 ml-5 bg-blumine"
        >
          <img class="w-6 h-6" src="./assets/icons/backspace_white.svg" alt="search" />
        </button>
        <button
          *isAllowed="[ERoleAdminString.Admin, 'company.export']"
          class="px-5 min-w-max btn btn--primary h-35 ml-5 bg-blumine"
          title="Download Excel com Empresas"
          (click)="downloadExcel()"
        >
          <img class="w-6 h-6" src="./assets/icons/download.svg" alt="Download Excel" />
        </button>
      </div>
    </div>
  </div>

  <app-list-companies
    [companies]="companies"
    [dadosPaginacao]="dadosPaginacao"
    (mudouPagina)="mudouPagina($event)"
    (mudouTamanhoPagina)="mudouTamanhoPagina($event)"
    (recarregarListagem)="carregarEmpresas()"
  ></app-list-companies>

  <hr class="mb-8" />

  <app-add-new-company (recarregarListagem)="carregarEmpresas()"></app-add-new-company>

  <hr class="my-8" *isAllowed="[ERoleAdminString.Admin, 'company.create']" />
</form>
